import { getLocalName } from 'vet-bones/utils';

import { JsonLdResult } from 'src/templates/queries/types';

export const getJsonLdResultLocalName = (result: JsonLdResult): string => {
  if (typeof result['@id'] === 'string') {
    return getLocalName(result['@id']);
  }
  if (result['@id']) {
    return getJsonLdResultLocalName(result['@id']);
  }
  return '';
};
